// extracted by mini-css-extract-plugin
export var container = "_4w-0";
export var icon = "_4w-1";
export var text = "_4w-2";